export enum FILE_TYPE {
    PAYROLLS = 'nomina',
    CONTRACTS = 'contrato',
    GENERALS = 'otros'
}